module.exports = __webpack_public_path__ + "img/distributionBoardImages-example.bdec54a9.jpg";